export function canBubbleFitInRectangle(bubble, rectangle, spacing) {
  const [x1, y1, x2, y2] = rectangle;
  const rectangleWidth = x2 - x1;
  const rectangleHeight = y2 - y1;

  return (
    rectangleWidth >= bubble.size.width + spacing && rectangleHeight >= bubble.size.width + spacing
  );
}
